import React, { useContext, Suspense } from "react";
import './TopBarRestau.css'
import logoBlack from '../../../image/logo/logoBlack.svg'
import QBlack from '../../../image/logo/QBlack.svg'
import { AppContext } from "../../../context/AppContext";
import { Link } from "react-router-dom";
import IconConnection from "../../../components/iconConnection/iconConnection";
import ChunkErrorBoundary from "../../../components/hook/chunkErrorBoundary";

const ConnectionScreen = React.lazy(() => import("../../ConnectionScreen/ConnectionScreen"));
interface interfaceTopBar {
    name: string,
    page:number,
    setPage: (value:number) => void,
}

const TopBar = ({name,page,setPage}:interfaceTopBar) => {

    const {connectionScreen} = useContext(AppContext)


    const clickContact = () => {
        setPage(1)
    }
    const clickMenu = () => {
        setPage(2)
    }
    const clickRestau = () => {
        setPage(3)
    }

    return (
        <>
        <div className='DoubleTopBar' >
            <div className="TopBarRestau">
                <Link to={"/"} className="LinkHomeScreen">
                    <img className="logoTopBarRestau" src={logoBlack} loading="lazy" alt="logo"/>
                    <img className="logoTopBarRestauTel" src={QBlack} loading="lazy" alt="logo"/> 
                </Link>
                <h1 className="title midTitle pointer" onClick={clickRestau}>{name}</h1>
                <div className="borderTitle elemComputer"></div>
                <div className="navigation">
                    <h2 className={`titleNav midTitle pointer ${page === 2 ? 'largeTitleBold' : 'midTitle'}`} onClick={clickMenu}>Menu</h2>
                    <h2 className={`titleNav midTitle pointer ${page === 3 ? 'largeTitleBold' : 'midTitle'}`} onClick={clickRestau} >Restaurant</h2>
                    <h2 className={`titleNav midTitle pointer ${page === 1 ? 'largeTitleBold' : 'midTitle'}`} onClick={clickContact}>Réservation</h2>
                </div>
                <IconConnection />
            </div>
            { connectionScreen && <div style={{zIndex:100,position:'relative'}}><ChunkErrorBoundary><Suspense fallback={null}> <ConnectionScreen /></Suspense></ChunkErrorBoundary> </div> }
        </div>
        
        
        </>
    )
}

export default TopBar